export const mediaQuery = {
  methods: {
    isMobile() {
      return this.$mq === "mobile" || this.$mq === "smallMobile";
    },

    isSmallMobile() {
      return this.$mq === "smallMobile";
    },
  },
};
